import React from "react";
import CreditCardOutlined from "@material-ui/icons/CreditCardOutlined";
import EqualizerOutlined from "@material-ui/icons/EqualizerOutlined";
import Storage from "@material-ui/icons/Storage";
import { CurrencyField, InfoPanel, StepHeader, useTranslation } from "./ui";

const fields = [
  [
    "averageSale",
    "Average Sales Amount Per Customer",
    "How much does a customer typically spend in a single credit or debit card transaction?",
    CreditCardOutlined
  ],
  [
    "highestSale",
    "Highest Estimated Sales Amount Per Customer",
    "What is the largest single credit or debit card transaction you expect to process?",
    EqualizerOutlined
  ],
  [
    "cardSales",
    "Estimated Monthly Credit and Debit Card Sales",
    "About how much do you expect to process in total credit and debit card sales each month?",
    Storage
  ]
];

export default function Account({
  application,
  errors,
  onApplicationTextChange
}) {
  const props = { application, errors, onApplicationTextChange };
  const t = useTranslation();
  return (
    <>
      <StepHeader
        title="Account Information"
        detail="These details help us configure your merchant account with the right processing limits and settings. Exact figures are not required. Just provide your best estimates."
      >
        A few quick estimates of your credit card sales.
      </StepHeader>
      <InfoPanel
        title="We ask for these estimates to properly set up your account."
        icon={EqualizerOutlined}
        featured
        checks={[
          "Sets the right processing limits",
          "Helps prevent account disruptions",
          "Protects your account from unusual activity"
        ]}
      >
        These amounts help us determine the appropriate processing limits,
        configure your account, and monitor for unusual activity for your
        protection.
      </InfoPanel>
      {fields.map(([name, label, hint, Icon]) => (
        <section key={name} className="merchant-estimate">
          <Icon className="merchant-estimate-icon" aria-hidden="true" />
          <div>
            <h2>
              {t(label)}
              <span className="merchant-required" aria-hidden="true">
                {" "}
                *
              </span>
            </h2>
            <p>{t(hint)}</p>
          </div>
          <CurrencyField
            {...props}
            name={name}
            ariaLabel={t(label)}
            placeholder={t("Enter amount")}
            required
          />
        </section>
      ))}
    </>
  );
}
